// Copyright (c) 2022-2026 Broadcom. All Rights Reserved.
// Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
// and/or its subsidiaries.

import { CspEnvironment } from "@vmw/csp-ngx-components";
import { AppConfig, CSP_PRODUCTION_HOST, CSP_SESSION_STORAGE_METHOD, Feature, ServiceState } from "@app/services/app-config/model";
import { ServiceTypeEnum } from "@api/generated/vcdr";
import { ConsoleType } from "@shared/models/global.model";

export const environment: AppConfig = {
    production: false,
    vipHost: "https://console.cloud.vmware.com",

    opConsoleOrgId: "f834a7b1-726f-4ebd-9ad9-fe82159e5246",
    opConsoleApiServer: "https://internal.api.ds-ppr.vmware.com",
    opConsoleClientId: "StCjwDgSHASoYj7pr2jaoWYzzXT0eQDxeMV",
    opConsoleServiceId: "5c7f382b-78ac-47be-8b78-53b6271564ad",

    selfServiceApiServer: "https://api.ds-ppr.vmware.com",

    services: new Map(
        [
            [ServiceTypeEnum.VCDR, {
                serviceState: ServiceState.ENABLED_SELF_SERVICE,
                clientId: "LacVZOQNStg2fDblTFtUZIDLTpVdMy3KKHA",
                serviceId: "1d1d04a1-2432-4b92-bdbc-43e1baaa78a0",
                selfServiceConsole: ConsoleType.VLR,
                features: [
                    Feature.SUBSCRIPTION_CHARTS,
                    Feature.VMC_USAGE_CHARTS,
                    Feature.DEPLOYMENT_FILTERS]
            }],
            [ServiceTypeEnum.VMCFS, {
                serviceState: ServiceState.ENABLED_SELF_SERVICE,
                clientId: "O85kKPo7tk4GB2Y5g5JdTfJOmDcjPHLAGyd",
                serviceId: "dd5ce1b1-bb94-4adc-8dfa-0eeeabe6d278",
                selfServiceConsole: ConsoleType.VMCFS,
                features: [Feature.SUBSCRIPTION_CHARTS]
            }],
            [ServiceTypeEnum.VMUA, {
                serviceState: ServiceState.ENABLED_SELF_SERVICE,
                clientId: "0a3d16da-67b8-4dda-9f7b-19782fef23af",
                serviceId: "d7056eff-2c22-4b2d-9a09-411bafe5beb8",
                selfServiceConsole: ConsoleType.QUORUM,
                features: []
            }]
        ]),

    cspServiceId: "5c7f382b-78ac-47be-8b78-53b6271564ad",
    cspEnvironment: CspEnvironment.PRODUCTION,
    cspOAuthConfig: {
        clientId: "LacVZOQNStg2fDblTFtUZIDLTpVdMy3KKHA",
        storage: CSP_SESSION_STORAGE_METHOD,
        scopes: [],
        cspHostname: CSP_PRODUCTION_HOST,
        resourceServers: [],
        requiredScopes: [],
        tokenExpirationBuffer: 20
    }
};
